import './_style.scss'
import Listener from '../../core/watcher/Listener'

Listener.onLoadDOM(() => {
   Listener.onClickAll('.footer-dropdown-toggle', event => {
      event.preventDefault()
      event.currentTarget.classList.toggle('footer-dropdown-toggle--opened')
      event.currentTarget.parentNode.querySelector('.footer-submenu')?.classList.toggle('footer-submenu--opened')
   })
})